module.exports = __webpack_public_path__ + "images/emoji/crossed_flags.fa2dcc01480342569568.png";